import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import { FaRegHandPointRight } from "react-icons/fa";
import { useNavigate, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import { FaHouseDamage } from 'react-icons/fa'
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import Row from 'react-bootstrap/Row';
import { editDataFromList, updateDataAPI } from '../../utils/api';
import ContentWrapper from '../../components/contentwrapper/ContentWrapper';

const initialState = {
    chanel_name: '',
}

const EditChanel = () => {
    const { slug } = useParams();
    const navigate = useNavigate();
    const [values, setInputValues] = useState(initialState);
    const [validated, setValidated] = useState(false);

    useEffect(() => {
        getSingleChanel(slug)
    }, [slug])

    
    const getSingleChanel = (slug) => {
        editDataFromList(`sub-admin-get-single-chanel-data/${slug}`).then((res) => {
            if (res.data.status === 1) {
                setInputValues(...[res.data.chaneldata])
            }
        })
    }

    const handleInputs = async (e) => {
        setInputValues({
            ...values,
            [e.target.name]: e.target.value,
        });
    };
    const handleUpdateChanel = async (event) => {
        event.preventDefault();
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.stopPropagation();
        }
        else {
            updateDataAPI(`sub-admin-update-chanel-data/${slug}`, values).then((res) => {
                if (res.data.status === 1) {
                    navigate("/all-subadmin-chanel");
                    toast.success("Chanel has been updated successfully!!")
                }
                else if (res.data.status === 2) {
                    toast.warning("Chanel already Exit!!")
                }
                else {
                    toast.warning("Check your connection!!");
                }
            })
        }
        setValidated(true);
    }
    return (
        <div className="addCompany">
            <Helmet>
                <title>SATKARTAR:SUB ADMIN::Edit Chanel</title>
            </Helmet>

            <ContentWrapper>
                <div className="col-xl-6">
                    <div className="card border-top border-0 border-4 border-danger">
                        <div className="card-body formbody">
                            <div className="card-title d-flex align-items-center">
                                <div>
                                    <FaHouseDamage className="formIcons" />
                                </div>
                                <h5 className="mb-0 text-danger">Edit Chanel</h5>
                            </div>
                            <hr />
                            <Form noValidate validated={validated} method="POST" onSubmit={handleUpdateChanel}>
                                <Row className="mb-3">
                                    <Form.Group as={Col} md="12" controlId="validationChanelName">
                                        <Form.Label>Chanel Name</Form.Label>
                                        <InputGroup hasValidation>
                                            <InputGroup.Text id="inputGroupPrepend"><FaHouseDamage /></InputGroup.Text>
                                            <Form.Control
                                                type="text"
                                                placeholder="Chanel Name"
                                                aria-describedby="inputGroupPrepend"
                                                required
                                                name="chanel_name"
                                                onChange={handleInputs}
                                                value={values?.chanel_name}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                <FaRegHandPointRight /> Please provide a valid chanel name.
                                            </Form.Control.Feedback>
                                        </InputGroup>
                                    </Form.Group>
                                    
                                </Row>
                                <Button type="submit">Update</Button>
                            </Form>
                        </div>
                    </div>
                </div>
            </ContentWrapper>
        </div>
    )
}

export default EditChanel